module.exports = __webpack_public_path__ + "img/mindfulness.ace3adaa.svg";